import { useQuery } from '@tanstack/react-query'

import { getAllItemCategories } from '@flecto/api/store'

type QueryPayload = {
  storeDomain: string
}

export function useQueryGetAllItemCategories({ storeDomain }: QueryPayload) {
  return useQuery({
    queryFn: async () => await getAllItemCategories(storeDomain),
    queryKey: ['QueryGetAllItemCategoriesV2'],
  })
}
